import {http} from '@/src/services/config/config-receituario'

export default{
    reportCfta:(token, dataIni, dataFim)=>{
        return http.get(`webservices/cfta?startDate=${dataIni}&endDate=${dataFim}`, {
            headers:{
                'Authorization':token
            }
        })
       
    },
    reportSiagro:(token, dataIni, dataFim)=>{
        return http.get(`webservices/siagro?startDate=${dataIni}&endDate=${dataFim}`, {
            headers:{
                'Authorization':token
            }
        })
    },
    syncSigen:(token, dataIni, dataFim)=>{
        return http.post('webservices/sigen/sync', {
            startDate: dataIni,
            endDate: dataFim,
        }, {
            headers:{
                'Authorization':token
            }
        })
    },
}
